module.exports = __webpack_public_path__ + "static/media/chevron-double-left.94728cff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-double-left.svg
// module id = 169
// module chunks = 0